import React from 'react';

import BooksOfAccountsModule from './books-of-accounts.module';
import BooksOfAccounts from 'enums/books-of-accounts';

const BooksOfAccountsGeneralLedgerModule = () => {
  return (
    <div>
      <BooksOfAccountsModule type={BooksOfAccounts.GeneralLedger} />
    </div>
  );
};

export default BooksOfAccountsGeneralLedgerModule;
